import { _Dimension___get_value__impl__urhqzrblez9tu1bx9v as _Dimension___get_value__impl__urhqzr } from './data.mjs';
import {
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
  ensureNotNull1e947j3ixpazm as ensureNotNull,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var measuringDiv;
function get_px(_this__u8e3s4) {
  _init_properties_data_js_kt__uvtked();
  return _Dimension___get_value__impl__urhqzr(_this__u8e3s4).get_roughPx_o6ay0o_k$();
}
function get_viewUnits(_this__u8e3s4) {
  _init_properties_data_js_kt__uvtked();
  return _Dimension___get_value__impl__urhqzr(_this__u8e3s4).get_roughPx_o6ay0o_k$();
}
var properties_initialized_data_js_kt_pnj137;
function _init_properties_data_js_kt__uvtked() {
  if (!properties_initialized_data_js_kt_pnj137) {
    properties_initialized_data_js_kt_pnj137 = true;
    var tmp = document.createElement('div');
    // Inline function 'kotlin.apply' call
    var this_0 = tmp instanceof HTMLDivElement ? tmp : THROW_CCE();
    this_0.id = '____--measuringDiv';
    this_0.style.height = '0';
    this_0.style.width = '0';
    this_0.style.position = 'absolute';
    this_0.style.outline = 'none';
    this_0.style.border = 'none';
    this_0.style.padding = 'none';
    this_0.style.margin = 'none';
    this_0.style.boxSizing = 'content-box';
    this_0.style.maxHeight = 'unset';
    ensureNotNull(document.body).appendChild(this_0);
    measuringDiv = this_0;
  }
}
//region block: exports
export {
  get_px as get_px1lajc6xaddk2r,
  get_viewUnits as get_viewUnits3uus4yl4di64,
};
//endregion

//# sourceMappingURL=data.js.mjs.map
